import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

import { downloadBankTransferFile } from '@src/api'
import { DefaultApiDownloadBankTransferFileRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks'

export const useDownloadBankTransferFile = (
  onSuccess?: (data: AxiosResponse<File>) => void
) => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiDownloadBankTransferFileRequest) =>
      downloadBankTransferFile(axiosInstance, params),
    onSuccess,
  })
}
